var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Modal } from "@skbkontur/react-ui";
var ModalStep = /** @class */ (function (_super) {
    __extends(ModalStep, _super);
    function ModalStep() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ModalStep.prototype.render = function () {
        var _a = this.props, header = _a.header, content = _a.content, footer = _a.footer, onNext = _a.onNext, width = _a.width, onPrev = _a.onPrev, onClose = _a.onClose, render = _a.render, stepIndex = _a.stepIndex, stepsCount = _a.stepsCount;
        return render ? (React.createElement(Modal, { onClose: onClose, width: width }, render({ onNext: onNext, onPrev: onPrev, onClose: onClose, stepIndex: stepIndex, stepsCount: stepsCount }))) : (React.createElement(Modal, { onClose: onClose, width: width },
            React.createElement(Modal.Header, null, header),
            React.createElement(Modal.Body, null, content),
            footer ? (footer({ onNext: onNext, onPrev: onPrev, onClose: onClose, stepIndex: stepIndex, stepsCount: stepsCount })) : (React.createElement(Modal.Footer, null,
                React.createElement(Button, { use: "primary", onClick: onNext }, "\u041F\u043E\u0435\u0445\u0430\u043B\u0438")))));
    };
    return ModalStep;
}(React.Component));
export { ModalStep };
